const pallete = {
  primary: {
    50: "#FDF9ED",
    100: "#F8ECCD",
    200: "#F0D897",
    300: "#EBC670",
    400: "#E3AA3C",
    500: "#DB8B25",
    600: "#C26A1D",
    700: "#A14D1C",
    800: "#843D1C",
    900: "#6C331B",
    950: "#3E190A",
  },
  blue: "#0088FF",
  orange: "#FF8D28",
  success: {
    main: "#22C55E",
    light: "#77ED8B",
    darkL: "#118D57",
    variant: "#46A278",
  },
  warning: {
    main: "#FFAB00",
    light: "#FFD666",
    dark: "#B76E00",
  },
  danger: {
    main: "#FF3B30",
    light: "#FFAC82",
    dark: "#B71D18",
  },
  background: {
    white: "#FFFFFF",
    black: "#121212",
    grey: "#F9FAFB",
  },
  grey: {
    100: "#F5F6F7",
    200: "#F4F6F8",
    300: "#DFE3E8",
    400: "#C4CDD5",
    500: "#919EAB",
    600: "#637381",
    700: "#454F5B",
    800: "#212B36",
  },
  indigo: {
    main: "#6155F5",
  },
};

export default pallete;
